/**
 * Cart Custom Fee Main - 购物车定制费主入口
 * 协调所有购物车定制费模块的初始化和运行
 * 
 * 依赖文件（按加载顺序）：
 * 1. cart-custom-fee-base-processor.js     - 基础处理器类
 * 2. cart-custom-fee-embroidery-processor.js - 刺绣工艺处理器
 * 3. cart-custom-fee-dtf-processor.js      - DTF工艺处理器
 * 4. cart-custom-fee-pvc-processor.js      - PVC工艺处理器
 * 5. cart-custom-fee-factory.js            - 工厂和配置
 * 6. cart-custom-fee-manager.js            - 核心管理器
 * 7. cart-custom-fee-main.js               - 本文件（主入口）
 */

// 初始化购物车定制费系统（防止重复创建实例）
if (!window.cartCustomFeeManager) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      window.cartCustomFeeManager = new CartCustomFeeManager();
    });
  } else {
    window.cartCustomFeeManager = new CartCustomFeeManager();
  }
}

// 提供便捷的调试接口
window.cartCustomFeeDebug = {
  // 开启调试模式
  enable() {
    localStorage.setItem('cart_custom_fee_debug', 'true');
    console.log('✅ 购物车定制费调试模式已开启');
    window.location.reload();
  },
  
  // 关闭调试模式
  disable() {
    localStorage.removeItem('cart_custom_fee_debug');
    console.log('✅ 购物车定制费调试模式已关闭');
    window.location.reload();
  },
  
  // 测试配置
  test() {
    if (window.cartCustomFeeManager) {
      window.cartCustomFeeManager.testCustomFeeConfig();
    } else {
      console.log('❌ 购物车定制费管理器未初始化');
    }
  },
  
  // 添加新工艺类型示例
  addCraftType(processType, config) {
    try {
      CartCustomFeeManager.addNewCraftType(processType, config);
    } catch (error) {
      console.error('❌ 添加工艺类型失败:', error);
    }
  }
};